import { render } from "./DuplicateObjective.vue?vue&type=template&id=56be5101&scoped=true"
import script from "./DuplicateObjective.vue?vue&type=script&lang=js"
export * from "./DuplicateObjective.vue?vue&type=script&lang=js"

import "./DuplicateObjective.vue?vue&type=style&index=0&id=56be5101&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56be5101"]])

export default __exports__